import { useCallback } from "react";
function useShallowSetState(setter, debug, debugName) {
  return useCallback(
    (next) => {
      setter((prev) => {
        for (const key in next) {
          if (prev[key] !== next[key]) {
            if (process.env.NODE_ENV === "development" && debug === "verbose") {
              console.warn(` \u25B2 setState ${debugName}`, next);
            }
            return { ...prev, ...next };
          }
        }
        return prev;
      });
    },
    [setter]
  );
}
export {
  useShallowSetState
};
//# sourceMappingURL=useShallowSetState.js.map
